// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_kd-0";